import { render, staticRenderFns } from "./OrderDetailModal.vue?vue&type=template&id=bc6abf02&scoped=true&"
import script from "./OrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModal.vue?vue&type=style&index=0&id=bc6abf02&lang=scss&scoped=true&"
import style1 from "./OrderDetailModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6abf02",
  null
  
)

export default component.exports